<script>	
    export let sentByMe;
	export let message;
</script>

<style>
.direct-chat-msg,
.direct-chat-text {
	display: block;
}
.direct-chat-msg {
	margin-bottom: 10px;
}
.direct-chat-msg:before,
.direct-chat-msg:after {
	content: " ";
	display: table;
}
.direct-chat-msg:after {
	clear: both;
}
.direct-chat-text {
	border-radius: 5px;
	position: relative;
	padding: 5px 10px;
	background: #ef4a50;
	margin: 2px 0 5px 50px;
	color: white;
    margin-left: 10px;
	margin-right: 30px;
}
.direct-chat-text:after,
.direct-chat-text:before {
	position: absolute;
	right: 100%;
	top: 15px;
	border: solid transparent;
	border-right-color: #ef4a50;
	content: ' ';
	height: 0;
	width: 0;
	pointer-events: none;
}
.direct-chat-text:after {
	border-width: 5px;
	margin-top: -5px;
}
.direct-chat-text:before {
	border-width: 6px;
	margin-top: -6px;
}
.right .direct-chat-text {
	margin-right: 10px;
	margin-left: 30px;
    color: black;
    background: #d2d6de;
}
.right .direct-chat-text:after,
.right .direct-chat-text:before {
	right: auto;
	left: 100%;
	border-right-color: transparent;
	border-left-color: #d2d6de;
}
</style>

<div class="direct-chat-msg" class:right="{sentByMe}" class:left="{!sentByMe}">
    <div class="direct-chat-text">
		<div class="d-flex">
			<span class="mr-auto">{@html message}</span>

		</div>
	</div>
</div>